/* eslint-disable react/jsx-no-bind */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import '@aerialist7/react-dates/initialize';
import moment from 'moment-timezone';
import DateRangePickerWrapper from '../DateRangePickerWrapper';

const DATE_FORMAT = 'YYYY-MM-DD';

class DateRange extends React.Component {
  static propTypes = {
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    startDatePlaceholderText: PropTypes.string,
    endDatePlaceholderText: PropTypes.string,
    onDatesChange: PropTypes.func.isRequired,
    showClearDates: PropTypes.bool,
    periods: PropTypes.arrayOf(PropTypes.object),
    disabled: PropTypes.bool,
  }

  static defaultProps = {
    showClearDates: true,
    periods: [],
  };

  constructor(props) {
    super(props);
    this.inner = React.createRef();
  }

  setPeriod = (days) => {
    const endDate = moment();
    const startDate = endDate.clone().subtract(days, 'days');
    this.inner.current.setState({ startDate, endDate });
    this.props.onDatesChange(startDate && startDate.format(DATE_FORMAT), endDate && endDate.format(DATE_FORMAT));
  }

  setAllTime = () => {
    this.inner.current.setState({ startDate: null, endDate: null });
    this.props.onDatesChange(null, null);
  }

  onDatesChange = ({ startDate, endDate }) => {
    // This is a workaround to handle the case where the user clears the dates
    // by clicking the clear button.
    // The library doesn't provide a way to detect this case, so we have to
    // wait for the dates to be cleared and then check if the values are empty.
    if (startDate === null && endDate === null) {
      setTimeout(() => {
        const elements = document.querySelectorAll('.DateInput_1 input');
        const values = Array.from(elements).map((element) => element.value);

        const startDateString = values[0];
        const endDateString = values[1];

        if (startDateString === '' && endDateString === '') {
          this.setAllTime();
        }
      }, 200);

      return;
    }

    if (startDate && endDate) {
      this.props.onDatesChange(startDate && startDate.format(DATE_FORMAT), endDate && endDate.format(DATE_FORMAT));
    }
  }

  render() {
    const { startDate, endDate } = this.props;
    const start = startDate ? moment(startDate, DATE_FORMAT) : null;
    const end = endDate && moment(endDate, DATE_FORMAT);

    return (
      <Fragment>
        <DateRangePickerWrapper
          ref={this.inner}
          initialStartDate={start}
          initialEndDate={end}
          onDatesChange={this.onDatesChange}
          block
          showClearDates
          disabled={this.props.disabled}
          startDatePlaceholderText={this.props.startDatePlaceholderText}
          endDatePlaceholderText={this.props.endDatePlaceholderText}
        />
        {this.props.periods.filter((period) => period.days).map((period, index) => {
          return (
            <button
              key={index}
              className='link-button link-button--lowercase link-button--margin'
              onClick={() => {
                if (this.props.disabled) return;

                this.setPeriod(period.days)
              }}
            >
              {period.label}
            </button>
          )
        })}
        {this.props.periods.length > 0 && (
          <button
            className='link-button link-button--lowercase link-button--margin'
            onClick={() => {
              if (this.props.disabled) return;

              this.setAllTime()
            }}
          >
            All time
          </button>
        )}
      </Fragment>
    )
  }
}

export default DateRange;
